<template>
  <SoPageWithRightSidePanel
    v-model="activeAccountFlow.current.isSidePanelCollapsed"
  >
    <v-progress-linear
      v-if="activeAccountFlow.isLoading"
      color="border"
      indeterminate
      data-testid="linear-progress-bar"
    />
    <div v-if="activeAccountFlow.accountStatus !== AccountStatuses.ACTIVE">
      <v-progress-linear
        v-if="activeAccountFlow.isLoading"
        color="border"
        indeterminate
        data-testid="linear-progress-bar"
      />
      <SoAlert
        v-else
        :title="`This account is ${activeAccountFlow.accountStatusFormatted}`"
        type="warning"
        class="ma-4"
        data-testid="cot-no-active-account"
      >
        Please fill in
        <SoLink :href="externalRoutes.ChangeOfTenancyTypeform.path"
          >this Typeform</SoLink
        >
        in order to progress a move in or move out on a Terminating account.
        <template
          v-if="
            activeAccountFlow.accountStatus !== AccountStatuses.NOT_ON_SUPPLY &&
            activeAccountFlow.activeAccountNumber
          "
        >
          To process a <b>move in</b> or a <b>move out</b> on this property, go
          to account number
          <SoLink
            :text="activeAccountFlow.activeAccountNumber"
            data-testid="cot-go-to-active-account"
            @click="
              $router.push(
                `/customer/${activeAccountFlow.activeAccountNumber}/cot`,
              )
            "
          />
        </template>
      </SoAlert>
    </div>
    <template v-else>
      <SoFlow
        :workflow-id="FlowType.ChangeOfTenancy"
        :account-number="activeAccountFlow.current.accountNumber"
        title="Change of Tenancy"
        start-step="start"
        data-testid="cot-flow"
        @closed="activeAccountFlow.closeFlow()"
      />
    </template>
    <SoFlowExit
      v-model="activeAccountFlow.isExitWorkflowModalOpen"
      @on-workflow-exit="activeAccountFlow.closeFlowConfirm"
    />
    <template #sidePanel>
      <CustomerAccountInfoPanel></CustomerAccountInfoPanel>
    </template>
    <template #sidePanelRail>
      <CustomerAccountInfoRail></CustomerAccountInfoRail>
    </template>
  </SoPageWithRightSidePanel>
</template>

<script lang="ts">
  import { AccountStatuses } from "@/models/account/account.types"
  import { FlowType } from "@/flows/useCases"
  import SoPageWithRightSidePanel from "@/components/templates/SoPageWithRightSidePanel.vue"
  import CustomerAccountInfoPanel from "../overview/CustomerAccountInfoPanel.vue"
  import CustomerAccountInfoRail from "../overview/CustomerAccountInfoRail.vue"
  import SoFlow from "@/flows/SoFlow.vue"
  import SoFlowExit from "@/flows/SoFlowExit.vue"
  import SoAlert from "@/components/SoAlert.vue"
  import SoLink from "@/components/SoLink.vue"
  import { useActiveAccountFlow } from "@/composables/useActiveAccountFlow"
  import { defineComponent } from "vue"
  import { externalRoutes } from "@/constants/routes/externalRoutes"

  export default defineComponent({
    components: {
      SoPageWithRightSidePanel,
      CustomerAccountInfoPanel,
      CustomerAccountInfoRail,
      SoFlow,
      SoFlowExit,
      SoAlert,
      SoLink,
    },

    data() {
      return {
        AccountStatuses,
        FlowType,
        activeAccountFlow: useActiveAccountFlow(),
        externalRoutes,
      }
    },
  })
</script>
